import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IPermission} from '../../../model/interfaces/permissions.interface';
import {UserPermissionsService} from './permissions.service';
import {ToastrService} from 'ngx-toastr';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-permissions',
    templateUrl: './permissions.component.html',
    styleUrls: ['./permissions.component.scss'],
    providers: [UserPermissionsService]
})
export class PermissionsComponent implements OnInit {

    public  loading = false;
    public userFullName = 'User';
    public  rows: Array<IPermission>;
    public cols: Array<any>;
    private originalRows: Array<IPermission>;
    public totalRecords = 0;

    constructor(
        private userPermissionsService: UserPermissionsService,
        private router: Router,
        private route: ActivatedRoute,
        private toastr: ToastrService,
        private title: Title
    ) {
        this.title.setTitle('User Profile');
        this.cols = [
            { field: 'name', header: 'System Key', visible: true, width: 33 },
            { field: 'description', header: 'Description', visible: true, width: 32 },
            { field: 'inheritsFromRole', header: 'Inherits From', visible: true, width: 20 },
            { field: 'hasPermission', header: 'Has Permission', visible: true, width: 15 }
        ];
    }

    ngOnInit() {
        this.loading = true;
        this.userPermissionsService.getPermissions(this.route.snapshot.params.id).subscribe( result => {
            this.userFullName = result.data.userFullName;
            this.loading = false;
            this.originalRows = result.data.permissions.map(item => {
                return Object.assign({}, item);
            });
            this.rows = result.data.permissions;
            this.totalRecords = result.data.permissions.length;
            window.dispatchEvent(new Event('resize'));
        }, error => {
            window.dispatchEvent(new Event('resize'));
            this.toastr.error('TimeOut occured', 'Service Error', {
                timeOut: 3000,
            });
        });
    }

    changeIndividualBehavior($event) {
        this.rows = this.rows.map(function (permission: IPermission) {
            if ($event.target.name === permission.name) {
                permission.hasPermission = !!$event.target.checked;
            }
            return permission;
        });
    }

    onCancel() {
        this.router.navigate(['user/profile/' + this.route.snapshot.params.id]);
    }

    savePermissions() {
        this.loading = true;
        this.userPermissionsService.savePermissions(this.route.snapshot.params.id, this.rows).subscribe(result => {
            this.loading = false;
            this.router.navigate(['user/profile/' + this.route.snapshot.params.id]);
        });
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/user/permissions/permissions.component.ts